import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../../../components/Collapsible';
import { FilterMake } from '../../Filter';
import { FilerMakePropTypes } from '../../Filter/FilterMakeModel/FilterMake';
import PropTypes from 'prop-types';

const CollapsibleMakes = ({makes, makeModels, position, loading, handleDataChange, params, tracking, label}) => {
  return (<CollapsibleContent initialState="closed">
    <CollapsibleHeader priority={0}>{label}</CollapsibleHeader>
    <Collapsible>
      <FilterMake
        makes={makes}
        makeModels={makeModels}
        position={position}
        loading={loading}
        handleDataChange={handleDataChange}
        params={params}
        tracking={tracking}
      />
    </Collapsible>
  </CollapsibleContent>);
};

CollapsibleMakes.propTypes = {
  ...FilerMakePropTypes,
  label: PropTypes.string,
};

export { CollapsibleMakes };
